import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Box } from '@mui/material';
import { Link, type LinkProps } from 'react-router-dom';

/**
 * Tillbakalänk överst på en sida (designprototyp v4): pil + text i
 * primär textfärg, utan understrykning, ovanför rubrikblocket.
 * Designsystemets AgronodLink stryker alltid under, därför en egen länk.
 */
export const TillbakaLank = ({
  to,
  children,
}: Pick<LinkProps, 'to'> & { children: string }) => (
  <Box
    component={Link}
    to={to}
    sx={(theme) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
      mb: 3,
      ...theme.typography.body2,
      fontWeight: 500,
      color: theme.palette.text.primary,
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline', textUnderlineOffset: 4 },
      '& svg': { fontSize: 18 },
    })}
  >
    <ArrowBackRoundedIcon />
    {children}
  </Box>
);
